import CrewHavingLicenseService from "@/views/enterprise/management/crews/crew-settings/service/crewHavingLicenseService";
import { CrewLicenseService } from "@/views/enterprise/management/crews/crew-settings/service/crewHavingLicenseService";

export default {
  /**
   * 資格定義リストを取得
   */
  async fetchLicenseDefinition({ commit }, payload = {}) {
    try {
      const res = await CrewLicenseService.fetchList(payload);
      console.log("res", res);
      const crewLicenseDefinitions = res.crew_licenses || [];
      console.log("crewLicenseDefinitions", crewLicenseDefinitions);
      commit("SET_LICENSE_DEFINITION", crewLicenseDefinitions);
      return crewLicenseDefinitions;
    } catch (error) {
      console.error("Error fetching license definition:", error);
      throw error;
    }
  },

  /**
   * 保有資格リストを取得
   */
  async fetchHavingLicense({ commit }, { enterpriseCrewId, payload = {} }) {
    try {
      const res = await CrewHavingLicenseService.fetchList(
        enterpriseCrewId,
        payload
      );
      const havingLicenses = res || [];
      const crewHavingLicenses = havingLicenses.crew_having_licenses || [];
      commit("SET_HAVING_LICENSE", crewHavingLicenses);
      return crewHavingLicenses;
    } catch (error) {
      console.error("Error fetching having license:", error);
      throw error;
    }
  },

  /**
   * 資格定義と保有資格を同時に取得
   */
  async fetchAllLicenseData(
    { commit, dispatch },
    {
      enterpriseCrewId,
      licenseDefinitionPayload = {},
      havingLicensePayload = {},
    }
  ) {
    try {
      await Promise.all([
        dispatch("fetchLicenseDefinition", licenseDefinitionPayload),
        dispatch("fetchHavingLicense", {
          enterpriseCrewId,
          payload: havingLicensePayload,
        }),
      ]);
    } catch (error) {
      console.error("Error fetching all license data:", error);
      throw error;
    }
  },

  /**
   * 保有資格を追加
   */
  async addHavingLicense({ commit }, { enterpriseCrewId, payload }) {
    try {
      const res = await CrewHavingLicenseService.add(enterpriseCrewId, payload);
      commit("ADD_HAVING_LICENSE", res);
      return res;
    } catch (error) {
      console.error("Error adding having license:", error);
      throw error;
    }
  },

  /**
   * 保有資格を更新
   */
  async updateHavingLicense({ commit }, { enterpriseCrewId, id, payload }) {
    try {
      const res = await CrewHavingLicenseService.update(
        enterpriseCrewId,
        id,
        payload
      );
      commit("UPDATE_HAVING_LICENSE", res);
      return res;
    } catch (error) {
      console.error("Error updating having license:", error);
      throw error;
    }
  },

  /**
   * 保有資格を削除
   */
  async deleteHavingLicense({ commit }, { enterpriseCrewId, id }) {
    try {
      await CrewHavingLicenseService.deleteById(enterpriseCrewId, id);
      commit("DELETE_HAVING_LICENSE", { id });
      return true;
    } catch (error) {
      console.error("Error deleting having license:", error);
      throw error;
    }
  },

  /**
   * 保有資格を取得（単一）
   */
  async fetchHavingLicenseById({ commit, state }, { enterpriseCrewId, id }) {
    try {
      const res = await CrewHavingLicenseService.fetchById(
        enterpriseCrewId,
        id
      );
      // 既存のリストに存在する場合は更新、存在しない場合は追加
      const existingIndex = state.having_license.findIndex(
        item => item.id === res.id
      );
      if (existingIndex !== -1) {
        commit("UPDATE_HAVING_LICENSE", res);
      } else {
        commit("ADD_HAVING_LICENSE", res);
      }
      return res;
    } catch (error) {
      console.error("Error fetching having license by id:", error);
      throw error;
    }
  },

  /**
   * 保有資格を取得（複数ID、並列処理）
   */
  async fetchHavingLicenseByIds(
    { commit, state },
    { enterpriseCrewId, ids = [] }
  ) {
    try {
      if (!ids || ids.length === 0) {
        return [];
      }

      // 複数のIDを並列で取得
      const fetchPromises = ids.map(id =>
        CrewHavingLicenseService.fetchById(enterpriseCrewId, id).catch(
          error => {
            console.error(`Error fetching license id ${id}:`, error);
            return null;
          }
        )
      );

      const results = await Promise.all(fetchPromises);

      // null値（エラー）を除外して有効なデータのみ処理
      const validResults = results.filter(res => res !== null);

      // ストアに反映（既存なら更新、なければ追加）
      validResults.forEach(res => {
        const existingIndex = state.having_license.findIndex(
          item => item.id === res.id
        );
        if (existingIndex !== -1) {
          commit("UPDATE_HAVING_LICENSE", res);
        } else {
          commit("ADD_HAVING_LICENSE", res);
        }
      });

      return validResults;
    } catch (error) {
      console.error("Error fetching having licenses by ids:", error);
      throw error;
    }
  },

  /**
   * ステートをリセット
   */
  resetState({ commit }) {
    commit("RESET_STATE");
  },
};
